/* Telling friends you're on, and which room you're in. A ping a minute while the app is open and visible,
   and one right away when you join or leave a room. */
import { call, backendReady } from './supa'
import { useMe } from './session'

let room: { code: string; kind: string } | null = null
let timer: ReturnType<typeof setInterval> | null = null

function ping() {
  if (!backendReady || !useMe.getState().me || document.visibilityState !== 'visible') return
  void call('ping', { p_room: room?.code ?? null, p_kind: room?.kind ?? null }).catch(() => {})
}

export function startOnline() {
  if (timer) return
  timer = setInterval(ping, 60_000)
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') ping() })
  useMe.subscribe((s, prev) => { if (s.me?.id && s.me.id !== prev.me?.id) ping() })
}

export function setActivity(next: { code: string; kind: string } | null) {
  if (room?.code === next?.code && room?.kind === next?.kind) return
  room = next
  ping()
}
